'use client';

interface ActivityListSkeletonProps {
  count?: number;
}

export const ActivityListSkeleton: React.FC<ActivityListSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className="px-4 md:px-6 lg:px-8 pt-2 md:pt-6">
      <div className="flex flex-col md:flex-row gap-6 h-full justify-center">
        {/* Activities List Skeleton */}
        <div className="flex-1 max-w-3xl overflow-y-auto space-y-3 h-full">
          {Array.from({ length: count }, (_, index) => (
            <ActivityCardSkeleton key={index} />
          ))}
        </div>

        {/* Right Side Skeleton - Desktop Only */}
        <div className="hidden md:block w-100">
          <div className="bg-white rounded-lg border border-gray-200 h-full">
            <div className="flex flex-col items-center justify-center h-full overflow-hidden">
              <div className="w-full relative">
                {/* LandingWrapper Skeleton */}
                <div className="min-h-[500px] relative">
                  {/* Visual Section Skeleton */}
                  <div className="relative w-full h-[300px] mb-6">
                    <div className="absolute left-0 bottom-[25%] w-[30%]">
                      <div className="aspect-square bg-gray-200 rounded-md animate-pulse"></div>
                    </div>
                    <div className="absolute left-[33%] top-[5%] w-[39%]">
                      <div className="aspect-[169/213] bg-gray-200 rounded-md animate-pulse"></div>
                    </div>
                    <div className="absolute right-0 top-[44%] w-[25%]">
                      <div className="aspect-square bg-gray-200 rounded-md animate-pulse"></div>
                    </div>
                  </div>
                </div>

                {/* Button Skeleton */}
                <div className="text-center pb-6 flex justify-center items-center">
                  <div className="h-10 bg-gray-200 rounded animate-pulse w-40"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActivityCardSkeleton: React.FC = () => {
  return (
    <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-white rounded-lg border border-gray-200">
      {/* Image Skeleton */}
      <div className="flex-shrink-0 w-20 h-20 rounded-lg bg-gray-200 animate-pulse"></div>

      {/* Content Skeleton */}
      <div className="flex-1 min-w-0 space-y-2">
        {/* Title and Professional Name */}
        <div className="space-y-1">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
          <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2"></div>
        </div>

        {/* Location and Slots Info */}
        <div className="flex gap-4">
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-16"></div>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-20"></div>
          </div>
        </div>
      </div>

      {/* Price Skeleton */}
      <div className="flex-shrink-0 text-right space-y-1">
        <div className="h-5 bg-gray-200 rounded animate-pulse w-16"></div>
        <div className="h-3 bg-gray-200 rounded animate-pulse w-12"></div>
      </div>
    </div>
  );
};
